/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Aggregators } from '../../models/aggregators';

export interface AggregatorsGet$Params {
}

export function aggregatorsGet(http: HttpClient, rootUrl: string, params?: AggregatorsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Aggregators>> {
  const rb = new RequestBuilder(rootUrl, aggregatorsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Aggregators>;
    })
  );
}

aggregatorsGet.PATH = '/aggregators';
